import { render, staticRenderFns } from "./BaseModalEx.vue?vue&type=template&id=1050c236"
import script from "./BaseModalEx.vue?vue&type=script&lang=js"
export * from "./BaseModalEx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports